export default "__VITE_ASSET__ab34ebe8__"